import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchRequests = ({ accountId }) => get(`/accounts/${accountId}/requests`);

export const addRequest = ({ accountId, employeeId, typeId, branchId, jobTypeId, startTime, endTime }) =>
  post(`/accounts/${accountId}/requests`, {
    typeId,
    employeeId,
    branchId,
    data: { startTime, endTime, jobTypeId }
  });

export const updateRequest = ({ accountId, requestId, ...body }) =>
  patch(`/accounts/${accountId}/requests/${requestId}`, body);

export const updateBulkRequests = ({ accountId, ...body }) => patch(`/accounts/${accountId}/requests/bulk`, body);

export const fetchPaginatedRequests = ({
  accountId,
  status,
  branchIds,
  page,
  pageSize,
  searchTerm,
  bookerId,
  requestIds
}) =>
  get(`/accounts/${accountId}/requests/paginated`, {
    status,
    branches: branchIds,
    page,
    pageSize,
    searchTerm,
    bookerId,
    requestIds
  });

export const fetchRequestsStats = ({ accountId }) => get(`/accounts/${accountId}/requests/stats`);

export const deleteRequest = ({ accountId, requestId }) => httpDelete(`/accounts/${accountId}/requests/${requestId}`);
